<template>
  <div class="outer-wrapper">
    <div class="inner-page animate__animated animate__slideInRight">
      <div class="container-fluid">
        <div class="card card-form ">
          <div class="card-body p-0">
            <b-form @submit.prevent="updateLead">
               <b-form-group id="input-group-1" label="Name" label-for="name">
                <b-form-input id="name" type="text" placeholder="Name" v-model="$v.lead.name.$model"></b-form-input>
              </b-form-group>
              <div class="error" v-if="$v.lead.name.$error">Field is required</div>
              <div class="form-group">
                <label for="">Status</label>
                <select class="custom-select"  v-model="$v.lead.status_id.$model">
                  <option selected="selected" disabled>Select Status</option>
                  <option v-for="status in statusList" :value="status.id">{{status.name}}</option>
                </select>
                <div class="error" v-if="$v.lead.status_id.$error"> Field is required</div>
              </div>
              <div class="form-group" v-if="deadStatusIds.includes(lead.status_id)">
                <label for="">Dead Reasons</label>
                <select class="custom-select"  v-model="lead.dead_reason" :required="deadStatusIds.includes(lead.status_id)">
                  <option selected="selected" disabled>Select Reason</option>
                  <option v-for="d in deadReasonList" :value="d.id">{{d.name}}</option>
                </select>
              </div>
              <div class="form-group">
                <label for="">City</label>
                <select class="custom-select"  v-model="lead.city_id">
                  <option selected="selected" disabled>Select City</option>
                  <option v-for="c in cityList" :value="c.id">{{c.name}}</option>
                </select>
              </div>
              <b-form-group id="input-group-1" label="Budget" label-for="Budget">
                <b-form-input id="budget" type="text" placeholder="Budget" v-model="$v.lead.budget.$model"></b-form-input>
              </b-form-group>
              <div class="error" v-if="$v.lead.budget.$error">Should be Valid</div>
              <div class="comment_details" v-html="lead.comments"></div>
              <b-form-group id="input-group-1" label="Add Comment" label-for="comment">
                <b-form-textarea id="comment" v-model="lead.users_comments" placeholder="Add Comment" rows="3" max-rows="6"></b-form-textarea>
              </b-form-group>
              <b-form-group>
                <div class="row mt-4">
                  <div class="col-8">
                    <b-button type="submit" variant="primary" block :disabled="$v.$invalid">Update Lead</b-button>
                  </div>
                  <div class="col-4 text-center">
                    <router-link class="btn btn-primary-outline text-muted" :to="{name: 'Lead', id: $route.params.id}" > Cancel</router-link>
                  </div>
                </div>
              </b-form-group>
            </b-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { required, minValue } from 'vuelidate/lib/validators';
import { validationMessage } from 'vuelidate-messages'
import {updateLeadParams} from '@/assets/scripts/utility.js';
const formMessages = {
  required: () => 'Field is required'
}
export default {
  name: "EditLead",
  data() {
    return {
      lead: {},
    };
  },
  validations: {
    lead: {
      name: {
        required
      },
      status_id: {
        required
      },
      budget: {
        minValue: minValue(1),
      }
    }
  },
  created(){
    this.fetchLeadDetail();
  },
  methods: {
    fetchLeadDetail(){
      let uuid = this.$route.params.id;
      this.$axios.get(`leads/${uuid}`).then((res) => {
        this.lead = res.data.lead;
        if (this.lead.comments) {
          this.lead.comments = this.lead.comments.replaceAll('\n', '<br>')
        }
      });
    },
    updateLead() {
      let uuid = this.$route.params.id;
      let params = updateLeadParams(this.lead)
      this.$axios
        .put(`leads/${uuid}`, { lead: params })
        .then(res => {
          swal({
            title: "Lead Updated!",
            icon: "success"
          }).then(this.$router.replace({ name: "Lead", params: { id: this.$route.params.id } }));
        })
      .catch(err => {
        if (err.response.status === 500) {
          swal({
            title: "Server Error!",
            icon: "error"
          });
        } else {
          swal({
            title: "Error",
            text: err.response.data.message,
            icon: "error"
          });
        }
      });
    },
  },
  computed: {
    statusList() {
      return this.$store.getters.statusesMaster;
    },
    cityList() {
      return this.$store.getters.cities;
    },
    validationMsg(){
      return validationMessage(formMessages);
    },
    deadReasonList() {
      return this.$store.getters.deadReasons;
    },
    deadStatusIds() {
      return this.$store.getters.deadStatusIds;
    },
  },
};
</script>
<style scoped>
  .comment_details {
    font-size: 13px;
    color: #666666;
  }
</style>

